<template>
  <ListeDemandeCommande />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListeDemandeCommande from "@/components/GesCom/DemandeCommande/ListeDemandeCommande.vue";

export default defineComponent({
  name: "ListeDemandeCommandePage",
  components: { ListeDemandeCommande },
});
</script>
